import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { HttpClient } from '@angular/common/http';
import { ITinggEncryptResponse } from '@boma/website/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  encryptPaymentRequest(params: {
    merchantTransactionID: string;
    customerFirstName: string;
    customerLastName: string;
    msisdn: string;
    customerEmail: string;
    requestAmount: string;
    currencyCode: string;
    accountNumber: string;
    serviceCode: string;
    dueDate: string;
    requestDescription: string;
    countryCode: string;
    languageCode: string;
    successRedirectUrl: string;
    failRedirectUrl: string;
    paymentWebhookUrl: string;
  }) {
    console.log(params);
    return this.httpClient.post<ITinggEncryptResponse>(
      `${this.base}api/v${this.version}/Checkout/Tingg/Encryption`,
      params
    );
  }
}
